<template>
  <div class="office-selector">
    <button class="office-selector__button" data-toggle="modal" @click.prevent="onClick">
      <svg-icon icon="lh-location-marker" width="16" height="16"></svg-icon>
      <div>
        <span>{{ locationName }}</span>
        <svg-icon icon="lh:chevron/down" width="12" height="12"></svg-icon>
      </div>
    </button>
    <office-selector-dialog v-if="visible"
                            id="office-selector-dialog" data-qa="office-selector-dialog"
                            v-model="visible"
                            :options="options"
                            :reference-description="referenceDescription"
                            :current-location="location"
                            @save="onSave"
    ></office-selector-dialog>
  </div>
</template>

<script>
import {post} from "@/common/fetch";
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import OfficeSelectorDialog from "./OfficeSelectorDialogComponentDesktop.vue";
import {haversineDistance} from "@/common/util/geoLocationHelper";

export default {
  components: {
    SvgIcon,
    OfficeSelectorDialog,
  },
  props: {
    location: Object,
    language: String,
  },
  data() {
    return {
      visible: false,
      options: null,
      referenceDescription: null,
    };
  },
  computed: {
    locationName() {
      // 10450 местоположение агентства на бэке берется из кэша сервиса статики, который в Name возвращает ру локализацию
      const names = this.location.optionalLanguageNames;
      const languageNamePair = names.find(x => x.languageCode.toLowerCase() === this.language.toLowerCase());
      if (!!languageNamePair) {
        return languageNamePair.value;
      }
      
      return this.location.name;
    }
  },
  methods: {
    onSave(selectedLocationId) {
      post("/Layout/ChangeTourOperatorOffice", { locationId: selectedLocationId }).then(serviceResponse => {
        if(serviceResponse.isSucceeded) {
          this.visible = false;
          this.$emit("tour-operator-office:change", serviceResponse);
          document.dispatchEvent(new Event('tour-operator-office:change'));
        } else {
          console.log("Failed to change tour operator office.", serviceResponse.errorDescription);
        }
      });
      localStorage.setItem("is_office_changed", "true");
    },
    
    onClick() {
      const {location} = this;
      if (!location) {
        console.error("Location is not provided.");
        return;
      }

      post("/Layout/GetTourOperatorOfficeOptions", {}, true).then(serviceResponse => {
        if (serviceResponse.IsSucceeded) {
          this.options = {
            regionIds: serviceResponse.RegionIds,
            locationIds: serviceResponse.LocationIds,
            topLocationIds: serviceResponse.TopLocationIds,
            mainCountryId: serviceResponse.MainCountryId,
          };
          this.referenceDescription = serviceResponse.ReferenceDescription;
          this.visible = true;
        } else {
          console.error(serviceResponse.ErrorDescription);
        }
      });
    },
    setOfficeByGeolocation() {
      const isOfficeChanged = localStorage.getItem("is_office_changed");
      if(isOfficeChanged) return;

      navigator.geolocation.getCurrentPosition(position => {
        post("/Layout/GetTourOperatorOfficeOptions", {}, true).then(serviceResponse => {
          if (serviceResponse.IsSucceeded) {
            const currentPoint = {
              longitude: position.coords.longitude,
              latitude: position.coords.latitude,
            };

            const cities = serviceResponse.LocationIds.map((locationId) => {
              return serviceResponse.ReferenceDescription.Locations.find(location => location.Id === locationId)
            })

            const citiesDistances = [];
            cities.forEach(city => {
              if (city.Coordinates) {
                const cityPoint = {
                  longitude: +city.Coordinates.Longitude,
                  latitude: +city.Coordinates.Latitude,
                };
                citiesDistances.push({
                  id: city.Id,
                  distance: haversineDistance(currentPoint, cityPoint),
                });
              }
            });

            if (citiesDistances.length === 0) return;

            let closestCity;
            if (citiesDistances.length === 1) {
              closestCity = citiesDistances[0];
            } else {
              closestCity = citiesDistances.reduce((prev, curr) => (prev.distance < curr.distance ? prev : curr));
            }

            if (!closestCity) return;
            if (closestCity.id === this.location.id) return;

            this.onSave(closestCity.id);
          }
        });
      })
    }
  },
  mounted() {
    this.setOfficeByGeolocation();
  }
};
</script>

<style lang="scss" scoped>


.office-selector {

}

.office-selector__button {
  display: flex;
  flex-flow: row nowrap;
  gap: 4px;
  align-items: center;
  border: 0;
  background-color: transparent;
  color: var(--main-10);
  height: 20px;
  line-height: 20px;
  white-space: nowrap;

  > svg {
    flex: 0 0 auto;
  }

  > div {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 4px;

    > svg {
      flex: 0 0 auto;
    }
  }

  &:hover {
    > div {
      border-bottom: 1px solid currentColor;
    }
  }
}
</style>
